import React, { Component } from "react";
import Rodal from "rodal";

import ApprovalAllConfirmDialog from "./ApprovalAllConfirmDialog";

export default class ApprovalAllButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDialogVisible: false,
    };
  }

  showDialog = () => {
    this.setState({
      isDialogVisible: true,
    });
  };

  hideDialog = () => {
    this.setState({
      isDialogVisible: false,
    });
  };

  onClickConfirm = () => {
    this.hideDialog();
    this.props.action(this.props.filteredLeaves);
  };

  render() {
    return (
      <div>
        <Rodal
          width={800}
          height={613}
          visible={this.state.isDialogVisible}
          onClose={this.hideDialog}
        >
          <ApprovalAllConfirmDialog
            purpose={this.props.dialogPurpose}
            leavesCount={this.props.filteredLeaves.length}
            mainColor={this.props.mainColor}
            currentFilterNames={this.props.currentFilterNames}
            hideDialog={this.hideDialog}
            onClickConfirm={this.onClickConfirm}
          />
        </Rodal>
        <button
          type="button"
          className={"btn"}
          style={{
            width: "150px",
            backgroundColor: `${this.props.mainColor}`,
            color: "white",
          }}
          onClick={this.showDialog}
        >
          {this.props.label}
        </button>
      </div>
    );
  }
}
